<template>
  <div class="supported-sites f-center f-column mt-6 mb-auto">
    <div v-if="$i18n.locale !== 'zh'">
      <div class="weight_500 mb-3 text-medium">
        {{ $t('upload.supported_sites') }}
      </div>
      <div class="supported-sites_cont text-medium clr-grey">
        <div
          v-for="site in supportedSites"
          :key="site.img"
          class="supported-sites_site pb-2 weight_500"
        >
          <img
            class="img-logo my-auto mr-2"
            :src="getImage(site.img)"
          />
          <span>
            {{ site.name }}
          </span>
        </div>
      </div>
    </div>

    <div
      v-else
      class="pa-4"
    >
      上传模式支持几乎所有平台。该模式是通过Wizard解算出来的游戏树进行解析，只要你的手牌历史的游戏结构与Wizard目前有解算结果的游戏树相近，基本都可以解析，这与平台无关。如果你在上传过程中碰到问题，可以在Discord或者微信上联系我们。
    </div>
  </div>
</template>

<script>
import { allSitesOptions } from '@/helpers/constants'
import links_mix from '@/mixins/links_mix'

export default {
  name: 'UploadBoxes',
  mixins: [links_mix],
  props: {
    tab: { default: () => '' },
  },
  data() {
    this.supportedSites = allSitesOptions()
    return {}
  },
  methods: {
    getImage(site) {
      return new URL(`/src/assets/playhouses/${site}.webp`, import.meta.url).href
    },
  },
  computed: {
    supportedFormats() {
      return [
        { name: `${this.$t('gametypes.groups.cash_long')}`, enabled: true },
        // { name: `${this.$t('gametypes.groups.cash_long')} <span class="text-small clr-grey">(${this.$t('gametypes.6max')})</span>`, enabled: true },
        // { name: `${this.$t('gametypes.groups.cash_long')} <span class="text-small clr-grey">(${this.$t('gametypes.8max')})</span>`, enabled: true },
        // { name: `${this.$t('gametypes.groups.cash_long')} <span class="text-small clr-grey">(HU)</span>`, enabled: true },
        { name: this.$t('gametypes.groups.mtt_long'), enabled: true },
        { name: this.$t('gametypes.groups.spins_long'), enabled: true },
        { name: this.$t('gametypes.groups.husng_long'), enabled: true },
      ]
    },
  },
}
</script>
<style lang="scss" scoped>
// @media (max-width: 1024px) {
//   .analyze-upload {
//     // flex-direction: column;
//     &_left,
//     &_right {
//       width: 100% !important;
//       // margin: 2rem 0 !important;
//     }
//   }
// }
// .soon {
//   position: absolute;
//   padding: 0.3rem 0.5rem;
//   font-size: 0.5rem;
//   background: var(--clr-grey-2);
//   border-radius: 4px;
//   color: black;
//   text-transform: uppercase;
//   line-height: 1.1;
//   top: 0;
//   right: 0;
// }

// .highlighted {
//   background: var(--clr-black-1) !important;
// }
.supported-sites {
  color: var(--clr-grey-2);
  &_cont {
    display: flex;
    // align-items: center;
    // justify-content: center;
    width: 100%;
    padding: 0 1rem;
    flex-wrap: wrap;
  }
  &_site {
    display: flex;
    padding: 0 0 0 1rem;
    width: 50%;
    // color: var(--clr-white-0);
    img {
      height: 1.2rem;
      // width: 1.2rem;
      object-fit: contain;
      margin-right: 0.25rem;
    }
  }
}
// .gameformat_btn-cont {
//   // display: grid;
//   // grid-template-columns: 1fr 1fr;
//   // grid-gap: 4px;
// }
.gameformat_btn {
  font-size: 1rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  color: var(--clr-grey-2);
  &_enabled {
    color: white !important;
    .gameformat_btn_icon {
      color: var(--clr-primary);
    }
  }
  &_icon {
    color: var(--clr-grey-2);
    margin-right: 6px;
    // position: absolute;
  }
}

// .paste-text {
//   // justify-content: flex-start !important;
//   text-align: left !important;
//   word-break: break-all;
//   overflow: hidden;
//   position: relative;
//   background: var(--clr-black-3) !important;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   flex: 1;
//   textarea {
//     position: relative;
//     z-index: 2;
//     overflow: auto;
//     color: var(--clr-white-0);
//     height: 100%;
//     width: 100%;
//     flex: 1;
//     resize: none;
//     padding: 0 0.5rem;
//   }
//   .text-area-help {
//     position: relative;
//     position: absolute;
//     z-index: 1;
//     color: var(--clr-grey-2);
//     flex: 1;
//   }
//   &:hover {
//     cursor: text !important;
//   }
// }
// .current-uploads {
//   width: 24rem;
//   padding: 0 0 1rem 0;
//   display: flex;
//   flex-direction: column-reverse;
// }
// .analyze-upload {
//   height: var(--vh-6);
//   display: flex;
//   flex-direction: column;
//   &_left,
//   &_right {
//     position: relative;
//     display: flex;
//     align-items: center;
//     flex-direction: column;
//     // min-height: var(--vh-6);
//     flex: 1;
//     padding-bottom: 2rem;
//   }
//   &_tabs {
//     max-height: 3rem;
//   }

//   .upload-container {
//     border-radius: 16px;
//     flex: 1;
//     width: 23rem;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     flex-direction: column;
//     padding: 2rem 1rem;
//     text-align: center;
//     background: var(--clr-black-1);
//     margin: 0 0 1rem 0;
//     border: solid grey 2px;
//     transition: background 0.2s;
//     position: relative;
//     &:not(.paste-text, .upload-disabled) {
//       &::before {
//         content: '';
//         width: 100%;
//         height: 100%;
//         position: absolute;
//         z-index: 1;
//       }
//     }
//     &_hovered:not(.upload-disabled) {
//       background: var(--clr-black-3);
//     }
//     &:hover:not(.upload-disabled) {
//       cursor: pointer;
//       background: var(--clr-black-3);
//     }
// .text-message {
//   font-size: 1rem;
//   font-weight: 700;
// }
//   }

//   .dashed {
//     border: dashed grey 2px !important;
//   }
//   &_icon {
//     font-size: 4rem;
//     color: var(--clr-grey-2);
//     margin-bottom: 1rem;
//     // position: absolute;
//   }
// }
// .btn-upload {
//   width: 10rem;
// }
</style>
